export  const Question = [
    {
        prompt: "The best cook in trenches is?",
        optionA: "Emmanuel",
        optionB: "Hammed",
        optionC: "Ishola",
        optionD: "Ayo",
        answer: "D",
    },
    {
        prompt: "Who is the sapa giver in trenches?",
        optionA: "Abigeal",
        optionB: "Idilabi",
        optionC: "Ebu",
        optionD: "Ajoke",
        answer: "C",
    },
    {
        prompt: "Name he person that enter school and ran back home?",
        optionA: "Davido",
        optionB: "Eniola",
        optionC: "Gift",
        optionD: "Okiki",
        answer: "B",
    },
    {
        prompt: "who is the best Osu?",
        optionA: "Cory",
        optionB: "Joe",
        optionC: "Harmon",
        optionD: "Bob",
        answer: "A",
    },
    {
        prompt: "The most serious in Trenches?",
        optionA: "Malik",
        optionB: "Hammed",
        optionC: "Ishola",
        optionD: "Ayo",
        answer: "A",
    },
    {
        prompt: "Who is trenches table tennis best player?",
        optionA: "Baddo",
        optionB: "Daddy Pems",
        optionC: "BJ",
        optionD: "Sule",
        answer: "B",
    },
    {
        prompt: "Babaoja of trenches is?",
        optionA: "Baddo",
        optionB: "daddy Dami",
        optionC: "Igwe",
        optionD: "Baba Gift",
        answer: "A",
    },
    {
        prompt: "The name of trenches street is?",
        optionA: "Portable str",
        optionB: "Alagomeji str",
        optionC: "Tijani str",
        optionD: "Adekunle Olaiya",
        answer: "D",
    },
    {
        prompt: "Highest Iphone own in trenches right now?",
        optionA: "xr",
        optionB: "7",
        optionC: "11 ",
        optionD: "11 pro",
        answer: "A",
    },
    {
        prompt: "The best song/album in trenches at the moment?",
        optionA: "Ruger",
        optionB: "Portable",
        optionC: "Seyi Vibes ",
        optionD: "Zinolisky",
        answer: "C",
    },            
]